<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
const flagsStore = useFlagsStore()
const appStore = useAppStore()

await callOnce('app-init', async () => {
  await Promise.all([flagsStore.fetchFlags(), appStore.fetchCountries()])
})

const { $htmlLang, $hrefLangLinks } = useNuxtApp()

useHead({
  htmlAttrs: {
    lang: $htmlLang
  },
  link: $hrefLangLinks,
  script: [
    {
      key: 'cookiebot',
      id: 'Cookiebot',
      src: 'https://consent.cookiebot.com/uc.js',
      type: 'text/javascript',
      ['data-cbid']: '0b6e9c22-7c32-46ab-aebf-9b0cf9bf2156'
    } as any
  ],
  style: [
    {
      key: 'cookiebot-styles',
      type: 'text/css',
      innerHTML:
        'a#CybotCookiebotDialogPoweredbyCybot, div#CybotCookiebotDialogPoweredByText { display: none !important; } #CookiebotWidget .CookiebotWidget-body .CookiebotWidget-main-logo { display: none !important; } .CookiebotWidget-main-logo { display: none !important; }'
    } as any
  ]
})
</script>
